/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransferDisclaimer } from '../../models/transfer-disclaimer';

export interface GetTransferdisclaimer$Json$Params {
  'api-version'?: string;
}

export function getTransferdisclaimer$Json(http: HttpClient, rootUrl: string, params?: GetTransferdisclaimer$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransferDisclaimer>>> {
  const rb = new RequestBuilder(rootUrl, getTransferdisclaimer$Json.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TransferDisclaimer>>;
    })
  );
}

getTransferdisclaimer$Json.PATH = '/transferdisclaimer';
